import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { formatIndianNumber } from "../../../Util/NumberConversion";

function ShareholdingPattern({ data = [], isSubScribe }) {
  const navigate = useNavigate();
  const [openSections, setOpenSections] = useState({
    promoters: true,
    publicOtherThanPromoters: true,
  });
  const [selectedYearPromoters, setSelectedYearPromoters] = useState("");
  const [selectedYearPublic, setSelectedYearPublic] = useState("");

  const getAvailableYears = () => {
    const years = Array.from(
      new Set(data.map((item) => item.financialYear))
    ).sort((a, b) => b - a);
    return years;
  };

  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedYearPromoters(years[0]);
      setSelectedYearPublic(years[0]);
    }
  }, [data]);

  // Filter data by categories
  const promotersData = data.filter(
    (item) =>
      item.category === "PROMOTERS" &&
      (selectedYearPromoters
        ? item.financialYear === selectedYearPromoters
        : true)
  );
  const publicOtherThanPromotersData = data.filter(
    (item) =>
      item.category === "PUBLIC/OTHER THAN PROMOTERS" &&
      (selectedYearPublic ? item.financialYear === selectedYearPublic : true)
  );

  // const formatIndianNumber = (value) => {
  //   return value ? value.toLocaleString() : "-";
  // };

  const toggleSection = (section) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const renderTable = (data) => (
    <div>
      {data.map((item) => (
        <div key={item.Id} className={styles.referencedoc_main}>
          <div>
            <b>Reference Documents</b>
          </div>

          <div className={styles.referencedoc_container}>
            {item.refDoc ? (
              <>
                <div>
                  {item.refDoc?.MaiinFileName && (
                    <a
                      href={item.refDoc?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item.refDoc?.MaiinFileName}
                    </a>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item.refDoc?.Attachments &&
                      item.refDoc?.Attachments.length > 0 ? (
                      item.refDoc?.Attachments.map((attachment, index) => (
                        <li
                          key={index}
                          className={styles.referencedoc_Attachments}
                        >
                          <IoDocumentTextOutline
                            size={16}
                            style={{
                              marginRight: "8px",
                              color: "white",
                            }}
                          />
                          <a
                            href={attachment.fileurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "white",
                            }}
                          >
                            {attachment.Name}
                          </a>
                          <button
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = attachment.fileurl;
                              link.download = attachment.Name;
                              link.click();
                            }}
                            title="Download"
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "#2961EF",
                              marginLeft: "5px",
                              textDecoration: "underline",
                            }}
                          >
                            <FiDownload />
                          </button>
                        </li>
                      ))
                    ) : (
                      <span>No attachments available.</span>
                    )}
                  </ul>
                </div>
              </>
            ) : (
              <span>No documents available for selected year</span>
            )}
          </div>
        </div>
      ))}
      <table className={styles.commantable}>
        <thead>
          {/* First row with category and equity/preference */}
          <tr className={styles.tableHeaderRow}>
            <th className={styles.tableHeader}>Category</th>
            <th className={styles.tableHeader}>Equity</th>
            <th className={styles.tableHeader}></th>
            <th className={styles.tableHeader}>Preference</th>
            <th className={styles.tableHeader}></th>
          </tr>
          {/* Second row with shares and percentages */}
          <tr>
            <th className={styles.tableHeader}></th>
            <th className={styles.tableHeader}>Number of Shares</th>
            <th className={styles.tableHeader}>Percentage</th>
            <th className={styles.tableHeader}>Number of Shares</th>
            <th className={styles.tableHeader}>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            // If there is no data, show a single row with "No data available"
            <tr>
              <td colSpan="5" className={styles.noDataRow}>
                No Share Holding Pattern available
              </td>
            </tr>
          ) : (
            // If data exists, render the table rows as before
            data.map((item, index) => (
              <React.Fragment key={index}>
                <tr className={styles.categoryRow}>
                  <td colSpan="5">1. Individual / Hindu Undivided Family</td>
                </tr>
                <tr>
                  <td>(i) Indian</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.indian_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.indian_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.indian_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.indian_pref_share_percentage || "-"}
                  </td>
                </tr>

                <tr>
                  <td>(ii) Non-resident Indian (others)</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.NRI_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.NRI_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.NRI_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.NRI_pref_share_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(iii) Foreign national (other than NRI)</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.foreign_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.foreign_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.foreign_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.foreign_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Government */}
                <tr className={styles.categoryRow}>
                  <td colSpan="5">2. Government</td>
                </tr>
                <tr>
                  <td>(i) Central Government</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.central_gov_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.central_gov_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.central_gov_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.central_gov_pref_share_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(ii) State Government</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.state_gov_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.state_gov_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.state_gov_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.state_gov_pref_share_percentage || "-"}
                  </td>
                </tr>
                <tr>
                  <td>(iii) Government companies</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.gov_companies_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.gov_companies_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.gov_companies_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.gov_companies_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Insurance companies */}
                <tr>
                  <td>3. Insurance companies</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.insurance_companies_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.insurance_companies_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.insurance_companies_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.insurance_companies_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Banks */}
                <tr>
                  <td>4. Banks</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.banks_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.banks_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.banks_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.banks_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Financial institutions */}
                <tr>
                  <td>5. Financial instutions</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.financial_instutions_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.financial_instutions_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.financial_instutions_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.financial_instutions_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Foreign institutional investors */}
                <tr>
                  <td>6. Foreign institutional investors</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.foreign_instutions_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.foreign_instutions_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.foreign_instutions_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.foreign_instutions_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Mutual funds */}
                <tr>
                  <td>7. Mutual funds</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.mutual_funds_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.mutual_funds_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.mutual_funds_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.mutual_funds_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Venture capital */}

                <tr>
                  <td>8. Venture capital</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.venture_capital_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.venture_capital_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.venture_capital_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.venture_capital_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Body corporate (not mentioned above) */}
                <tr>
                  <td>9. Body corporate (not mentioned above)</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.body_corporate_capital_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.body_corporate_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.body_corporate_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.body_corporate_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Others */}
                <tr>
                  <td>10. Others</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.others_capital_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.others_share_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.others_pref_share)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.others_pref_share_percentage || "-"}
                  </td>
                </tr>

                {/* Total */}
                <tr>
                  <td>Total</td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.total_shares)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.total_shares_percentage || "-"}
                  </td>
                  <td className={styles.tableCell}>
                    {formatIndianNumber(item.total_pref_shares)}
                  </td>
                  <td className={styles.tableCell}>
                    {item.total_pref_shares_percentage || "-"}
                  </td>
                </tr>
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className={styles.container}>
      {/* Show subscription message if not subscribed */}
      {!isSubScribe && (
        <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {/* Promoters Section */}
      {isSubScribe && (
        <>
          <h3 className={styles.highlet_text}>
            <div onClick={() => toggleSection("promoters")}>
              {openSections.promoters ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </div>
            {/* Promoters - 31 Mar, 2024 */}
            {/* Promoters -  31 Mar, {selectedYearPromoters || "-"} */}
            Promoters
            {promotersData.length > 0 && selectedYearPromoters && ` - 31 Mar, ${selectedYearPromoters}`}

            {promotersData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  id="year-select-promoters"
                  value={selectedYearPromoters}
                  onChange={(e) => setSelectedYearPromoters(e.target.value)}
                >
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}

          </h3>

          {openSections.promoters && (promotersData.length > 0 || true) ? ( // Ensuring headers are always shown
            <>{renderTable(promotersData)}</>
          ) : openSections.promoters && promotersData.length === 0 ? (
            <p className={styles.noDataRow}>No data available for Promoters</p>
          ) : null}
        </>
      )}

      {/* Public/Other Than Promoters Section */}
      {isSubScribe && (
        <>
          <h3 className={styles.highlet_text}>
            <div onClick={() => toggleSection("publicOtherThanPromoters")}>
              {openSections.publicOtherThanPromoters ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </div>
            {/* Public/Other Than Promoters - 31 Mar, 2024 */}
            {/* Public/Other Than Promoters -  31 Mar, {selectedYearPublic || "-"} */}
            Public/Other Than Promoters
            {promotersData.length > 0 && selectedYearPromoters && ` - 31 Mar, ${selectedYearPromoters}`}
            {promotersData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  id="year-select-public"
                  value={selectedYearPublic}
                  onChange={(e) => setSelectedYearPublic(e.target.value)}
                >
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </h3>

          {openSections.publicOtherThanPromoters &&
            (publicOtherThanPromotersData.length > 0 || true) ? (
            <>{renderTable(publicOtherThanPromotersData)}</>
          ) : openSections.publicOtherThanPromoters &&
            publicOtherThanPromotersData.length === 0 ? (
            <p className={styles.noDataRow}>
              No data available for Public/Other Than Promoters
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}

export default ShareholdingPattern;
